var map = {
	"./CHEERFY.png": 236,
	"./DELIVEROO.png": 4921,
	"./DIDI.png": 2474,
	"./DRIVE_THRU.png": 4626,
	"./FLIPDISH.png": 2487,
	"./FUDEAT.png": 3439,
	"./GLOVO.png": 9549,
	"./JUSTEAT.png": 9548,
	"./LOCAL.png": 5061,
	"./OTHERS.png": 8311,
	"./OWN_DELIVERY.png": 4425,
	"./PEDIDOSYA.png": 1544,
	"./TAKE_AWAY.png": 6778,
	"./UBER.png": 9046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1353;